import React, {Component} from 'react';
// import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';

class RedisGlobalVars extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_global_vars&only_json', (component, data) => {
                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    //

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    generateTableRows() {
        {
            // let data = JSON.parse(this.state.redis_data);
            // console.log("Generating table rows..");
            // console.log(data);
            // console.log(Object.values(data));

            return Object.entries(this.state.redis_data).map((value, i) => {
                // console.log(value);
                // console.log(value[0]);
                let k = value[0];
                let v = value[1];
                // console.log(v);

                return (
                    <tr key={k}>
                        <td>{k}</td>
                        <td>{v.toString()}</td>
                    </tr>
                );
            });
        }
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }

    render() {
        if (this.state.redis_data == null) return this.noDataPreloader();
        // console.log('rendering...');
        return (
            <table className="table">
                <thead>
                <tr>
                    <th scope="col">Var Name</th>
                    <th scope="col">Value</th>
                </tr>
                </thead>
                <tbody>
                {this.generateTableRows()}
                </tbody>
            </table>
        );
    }
}

export default RedisGlobalVars;



// WEBPACK FOOTER //
// ./src/components/redisGlobalVars.js